"use strict";

import angular from "angular";

import template from "./chart-structure.component.html";
import "./themes/chart-structure.component-dark.scss";
import "./themes/chart-structure.component.scss";

import _ from "lodash";

import moment from "moment";

import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
require("highcharts/highcharts-more")(Highcharts);

import { Company } from "../../../gateway/Company/Company";
import { AccountingAnalytics } from "../../../presentation/services/AccountingAnalytics/AccountingAnalytics";
import { ChartStructure } from "../../../presentation/services/ChartStructure/ChartStructure";
import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";
import {
    dark,
    light
} from "../../../presentation/services/HighchartsTheme/HighcharttsTheme";
import { SocialUser } from "../../../presentation/services/SocialUser/SocialUser";
class ChartCustomerpPortfolioStructureComponent {
    constructor($rootScope, $scope, $element, $filter, ThemesService) {
        Exporting(Highcharts);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$element = $element;

        this.$filter = $filter;
        this.ThemesService = ThemesService;

        this.AccountingAnalytics = new AccountingAnalytics({
            Company: new Company(),
            SocialUser: new SocialUser()
        });

        this.FormatUnits = new FormatUnits($filter);
        this.ChartStructure = new ChartStructure({
            FormatUnits: this.FormatUnits,
            ThemesService: this.ThemesService
        });

        this.chart = {};

        this.points = [];
        this.seriesProperties = [];
        this.dataValue = 0;
        this.unit = "";

        Highcharts.setOptions({
            lang: {
                months: [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro"
                ],
                shortMonths: [
                    "Jan",
                    "Fev",
                    "Mar",
                    "Abr",
                    "Mai",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Set",
                    "Out",
                    "Nov",
                    "Dez"
                ]
            }
        });

        const currentTheme = this.ThemesService.getTheme();

        if (currentTheme === "dark") {
            Highcharts.setOptions(dark);
        } else {
            Highcharts.setOptions(light);
        }

        const deregisterHighchartReflow = this.$scope.$on(
            "HIGHCHART_REFLOW",
            () => {
                this.reflow();
            }
        );

        const deregisterThemesService = this.$rootScope.$on(
            "THEMES_SERVICE_THEME_CHANGED",
            (event, theme) => {
                const currentTheme = this.ThemesService.getTheme();

                if (currentTheme === "dark") {
                    Highcharts.setOptions(dark);
                } else {
                    Highcharts.setOptions(light);
                }

                this.renderChart();
            }
        );

        this.$scope.$on("$destroy", () => {
            deregisterThemesService();
            deregisterHighchartReflow();
        });
    }

    $onInit() {
        this.AccountingAnalytics.setAccountingId(this.accountingId);

        this._setPointsAndSeries();
        this._setDataValue();
        this.renderChart();
    }

    $onChanges(changes) {
        if (
            typeof _.get(changes, "currentDate.previousValue") != "object" ||
            typeof _.get(changes, "currentFilters.previousValue") != "object"
        ) {
            this._setPointsAndSeries();
            this._setDataValue();
            this.renderChart();
        }
    }

    reflow() {
        if (this.chart) {
            const width = this.chart.renderTo.clientWidth;
            const height = this.chart.renderTo.clientHeight;
            this.chart.setSize(width, height, true);
        }
    }

    _setDataValue() {
        if (!this.kpiValue) return;

        const lastPoint = _.last(this.points);
        this.dataValue = lastPoint.v;
        this.unit = _.get(this.seriesProperties, "[0].unit");
    }

    _setPointsAndSeries() {
        const { series, points } = this._getPointsAndSeries();

        this.seriesProperties = series;
        this.points = points;
    }

    /**
     * @public
     * Metodo chamado pela series para gerar um array de series dinamico de acordo com o filed da empresa
     * @param {*} field
     * @param {*} baseId
     * @param {*} unit
     * @param {*} type
     * @returns
     */
    group({
        field,
        baseId,
        unit = "percentage",
        func,
        type = "column",
        refereceId,
        customStructure = {}
    } = {}) {
        this.fieldReference = field;
        const _ids = this.AccountingAnalytics.generateSeriesByField({
            field,
            baseId,
            unit,
            func,
            refereceId
        });

        let series = _ids.map((_id) => {
            return {
                _id,
                type,
                stack: "value",
                ...customStructure
            };
        });

        if (this.combinationSeries)
            series = series.concat(this.combinationSeries);

        return series;
    }

    _getPointsAndSeries() {
        const start = new Date(
            moment(this.currentDate).subtract(12, "month").format()
        );
        const end = new Date(moment(this.currentDate).format());

        if (typeof this.series === "string") {
            this.series = eval(this.series);
        }

        const seriesIds = this.series.map((serie) => serie._id);

        const selector = { _id: { $in: seriesIds } };
        const series = this.AccountingAnalytics.getSeries({ selector });

        const mergedSeries = this._mergeSeries({
            visualizationSeries: this.series,
            series
        });

        const filters = this._getFiltersWithValue(this.currentFilters);
        const points = this.AccountingAnalytics.result({
            serieIds: seriesIds,
            timesBetween: {
                start,
                end
            },
            filterQuery: filters
        });

        const index = points.findIndex((p) => {
            if (typeof p.v === "object") return p.v.total > 0;

            return p.v > 0;
        });
        const firstIndex = index;
        const filteredPoints = points.splice(
            firstIndex < 0 ? index : firstIndex
        );

        return { series: mergedSeries, points: filteredPoints };
    }

    _getFiltersWithValue(filters) {
        const fields = Object.keys(filters);
        const filtersCopy = { ...filters };

        fields.forEach((field) => {
            if (!filtersCopy[field]) delete filtersCopy[field];
        });

        return filtersCopy;
    }

    _getStructure(structure) {
        let series = this.seriesProperties;

        if (this.currentFilters[this.fieldReference]) {
            const listFieldsFilter = this.currentFilters[this.fieldReference]
                .$in;

            series = series.filter((serie) => {
                return listFieldsFilter.includes(serie.operation.value);
            });
        }

        const chartStructure = this.ChartStructure.format({
            structure,
            series,
            points: this.points
        });

        return chartStructure;
    }

    _mergeSeries({ visualizationSeries = [], series = [] } = {}) {
        return series.map((serie) => {
            const vizSerie = visualizationSeries.find(
                (s) => s._id === serie._id
            );

            return {
                ...serie,
                ...vizSerie
            };
        });
    }

    renderChart() {
        const element = this.$element[0].getElementsByClassName(
            "chart-structure_chart-wrapper"
        );

        let elemAngular = angular.element(element);
        if (this.kpiValue) elemAngular.addClass("wrapper-with-kpi");
        else elemAngular.addClass("wrapper-without-kpi");

        const structure = this._getStructure(this.structure);

        if (!structure.chart)
            structure.chart = {
                renderTo: element[0]
            };
        else structure.chart.renderTo = element[0];
        console.log(structure);
        this.chart = new Highcharts.Chart(structure);
    }
}

export { ChartCustomerpPortfolioStructureComponent };

ChartCustomerpPortfolioStructureComponent.$inject = [
    "$rootScope",
    "$scope",
    "$element",
    "$filter",
    "ThemesService"
];

const name = "chartStructureComponent";
const def = {
    bindings: {
        chartTitle: "<",
        structure: "<",
        series: "<",
        combinationSeries: "<",
        kpiValue: "<",
        currentDate: "<",
        currentFilters: "<",
        accountingId: "<"
    },
    controller: ChartCustomerpPortfolioStructureComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
